import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from './directives/directives.module';
import {PipeModule} from "./pipe/pipe.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    DirectivesModule,
    PipeModule,

  ],
  exports: [
    ComponentsModule,
    DirectivesModule,
    PipeModule
  ]
})
export class SharedModule { }
